import type { SVGProps } from 'react';
const DawnFlagCSA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CSA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CSA_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.857 12.84q0-.04.01-.08l.514-2.093.5-2.041a.33.33 0 0 0-.006-.183l-.452-1.379a.33.33 0 0 0-.165-.193l-.743-.378a.33.33 0 0 1-.182-.297V4.344q0-.077.034-.147l.49-.997.432-.88a.33.33 0 0 1 .3-.187h2.601c.184 0 .334.15.334.334v.4c0 .184.149.333.333.333h.38c.185 0 .334.15.334.333v.53c0 .125.07.24.182.296l1.731.882a.33.33 0 0 1 .182.297v.785q0 .076-.034.146l-.45.918a.34.34 0 0 1-.113.13l-1.425.967a.33.33 0 0 0-.112.129l-.97 1.974a.33.33 0 0 1-.112.13l-1.425.967a.33.33 0 0 0-.112.129l-.917 1.867a.33.33 0 0 1-.3.187H8.19a.333.333 0 0 1-.333-.334z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCSA;
